import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RiverDelta8TerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RIVER_DELTA8;
}

export default RiverDelta8TerrainTileEntity;
